import PageTitle from 'components/ui/pageTitle/pageTitle'
import React from 'react'
import FaqSection from './components/faqSection/faqSection'

export default function Faq() {
  return (
    <>
      <PageTitle>Frequently Asked Questions</PageTitle>
      <FaqSection />
    </>
  )
}
